import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paragraph, Subtitle } from '@components/Styled';
import { Notification as NotificationContainer } from '../NotificationCenter.style';
const PhoneChanged = (props) => {
    const { notification } = props;
    return (_jsxs(NotificationContainer, { children: [_jsx(Subtitle, { level: "3", children: "Tu tel\u00E9fono ha sido actualizado con \u00E9xito. Si no fuiste t\u00FA, contacta a soporte." }), _jsx(Paragraph, { color: "grayF", children: notification.getLocaleDate() })] }));
};
export default PhoneChanged;
